export default __webpack_public_path__ + "static/ItHelpDesk-417f16f82d7578bc8e025c3716ad09fb.svg";